type BibleVersionType = {
    kjv: 'kjv',
    esv: 'esv',
    nas: 'nas',
    nlt: 'nlt',
}
export const BibleVersions: BibleVersionType = {
    kjv: 'kjv',
    esv: 'esv',
    nas: 'nas',
    nlt: 'nlt',
}

export type BibleVersionsValues = typeof BibleVersions[keyof typeof BibleVersions]

export const AllBibleVersions: BibleVersionsValues[] = Array.from(Object.values(BibleVersions));

export const BibleVersionNames:{ [key in BibleVersionsValues]: string } = {
    [BibleVersions.kjv]: 'KJV',
    [BibleVersions.esv]: 'ESV',
    [BibleVersions.nas]: 'NASB',
    [BibleVersions.nlt]: 'NLT',
}

export const BibleVersionCopyright:{ [key in BibleVersionsValues]: string } = {
    [BibleVersions.kjv]: 'King James Version is in the PUBLIC DOMAIN except in the United Kingdom, where a Crown Copyright applies to printing the KJV. See http://www.cambridge.org/about-us/who-we-are/queens-printers-patent',
    [BibleVersions.esv]: 'Scripture quotations marked ESV are from the ESV® Bible (The Holy Bible, English Standard Version®), copyright © 2001 by Crossway Bibles, a publishing ministry of Good News Publishers. Used by permission. All rights reserved.',
    [BibleVersions.nas]: 'New American Standard Bible Copyright © 1960, 1971, 1977, 1995, 2020 by The Lockman Foundation, La Habra, Calif. All rights reserved. For Permission to Quote Information visit http://www.lockman.org.',
    [BibleVersions.nlt]: 'Holy Bible, New Living Translation®, copyright © 1996, 2004, 2015 by Tyndale House Foundation. All rights reserved. Used by permission of Tyndale House Publishers, Carol Stream, Illinois 60188. New Living Translation®, NLT®, and the New Living Translation® logo are registered trademarks of Tyndale House Ministries.',
}

export default BibleVersions;